<template>
    <div class="py-4">
        <modal-filter :onfilter="onfilter" :filter="filter" @onclose="onfilter = false" @onfilter="ONFILTER()" :exclude="['state_id']"/>
        <modal-reload v-if="onreload" :onreload="onreload" :item="item" @onclose="onreload = false" @onreload="ONFILTER()"/>
        <header>
            <div class="container-fluid">
                <div class="pb-4">
                    <div class="row align-items-end">
                        <div class="col-sm col-12">
                            <h1 class="h2 ls-tight">Rutas de Cierre</h1>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main>
            <div class="container-fluid">
                <div class="vstack gap-4">
                    <div class="d-flex flex-column flex-md-row gap-3 justify-content-between">
                        <form class="d-flex gap-3 row" @submit.prevent="FILTER()">
                            <div>
                                <button @click="onfilter = true" type="button" class="btn btn-h px-3 btn-neutral">
                                    <i class="bi bi-funnel me-2"></i>
                                    <span>Filtro</span>
                                    <span class="vr opacity-20 mx-3"></span>
                                    <span class="text-xs text-primary">{{ count_filter }}</span>
                                </button>
                            </div>
                            <div>
                                <button @click="SORT()" type="button" class="btn btn-h px-3 btn-neutral">
                                    <i class="me-2" :class="filter.sortDesc == 'ASC' ? 'bi bi-sort-alpha-up' : 'bi bi-sort-alpha-down-alt'"></i>
                                    <span>{{ filter.sortDesc }}</span>
                                </button>
                            </div>
                            <div class="col-md-2 px-0">
                                <div class="input-group input-group-sm input-group-inline">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text pe-2 text-sm"><i class="fa-solid fa-hashtag"></i></span>
                                    </div>
                                    <input type="text" class="form-control" @keypress="NUMBER" placeholder="Buscar No." v-model="filter.search">
                                </div>
                            </div>
                            <div>
                                <button type="submit" class="btn btn-h px-3 btn-primary">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="loading == 'filter'">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Buscar</span>
                                </button>
                            </div>
                            <div>
                                <button type="button" class="btn btn-h px-3 btn-danger" @click="CLEAR()">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="loading == 'clear'">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Limpiar</span>
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="card">
                        <div class="card-header bg-white">
                            <h5 class="me-auto">Listado</h5>
                        </div>
                        <div class="card-body p-0">
                            <template>
                                <v-data-table  class="elevation-1"
                                    :headers="headers"
                                    :items="loading == 'table' || loading == 'sort' || loading == 'filter' || loading == 'clear' ? [] : items.data"
                                    :options.sync="options"
                                    :server-items-length="items.total"
                                    :loading="loading == 'table' || loading == 'sort' || loading == 'filter' || loading == 'clear'"
                                    :footer-props="{
                                        'items-per-page-options': [5, 10, 50, 100]
                                    }">
                                    <template v-slot:[`item.updated_at`]="{ item }">
                                        {{ item.updated_at | DATE }}
                                    </template>
                                    <template v-slot:[`item.details`]="{ item }">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <a v-bind="attrs"
                                                    v-on="on">
                                                    <router-link
                                                        :to="{ name: 'DeliverRouteClosingDetail', params: { id: item.id } }"
                                                        class="btn btn-primary btn-m">
                                                        <small><i class="fa-solid fa-cubes"></i></small>
                                                    </router-link>
                                                </a>
                                            </template>
                                            <small>Abrir</small>
                                        </v-tooltip>
                                    </template>
                                    <template v-slot:[`item.print`]="{ item, index }">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <button @click="PRINT(item.id, index)"
                                                    type="button"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    class="btn btn-neutral btn-m">
                                                    <small class="d-flex justify-content-center align-items-center">
                                                        <div class="spinner-border spinner-border-sm mb-0" role="status" v-if="loadings.filter(e => e == index).length == 1">
                                                            <span class="sr-only">Loading...</span>
                                                        </div>
                                                        <i class="bi bi-printer" v-else></i>
                                                    </small>
                                                </button>
                                            </template>
                                            <small>Imprimir</small>
                                        </v-tooltip>
                                    </template>
                                    <template v-slot:[`item.open`]="{ item }">
                                        <v-tooltip top v-if="globalViewOption('OpenClosing')">
                                            <template v-slot:activator="{ on, attrs }">
                                                <button @click="ACTION(item)"
                                                    type="button"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    class="btn btn-m btn-info">
                                                    <small><i class="fa-solid fa-truck-fast fa-flip-horizontal"></i></small>
                                                </button>
                                            </template>
                                            <small>Abrir</small>
                                        </v-tooltip>
                                        <button class="btn btn-info btn-m" disabled v-else>
                                            <small><i class="fa-solid fa-truck-fast fa-flip-horizontal"></i></small>
                                        </button>
                                    </template>
                                </v-data-table>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
import ModalFilter from './modals/Filter'
import ModalReload from './modals/Reload'
export default {
    components: { ModalFilter, ModalReload },
    data() {
        return {
            headers: [
                { text: 'No.', value: 'id' },
                { text: 'Fecha Cierre', value: 'updated_at' },
                { text: '# Ruta/Sucursal', value: 'route.full_name' },
                { text: 'Nombre Ruta/Sucursal', value: 'route.full_name' },
                { text: 'Empleado', value: 'driver.name' },
                { text: 'Detalles', value: 'details', sortable: false },
                { text: 'Imprimir', value: 'print', sortable: false },
                { text: 'Abrir', value: 'open', sortable: false }
            ],
            items: {
                data: [],
                total: 0,
                to: 0
            },
            cancelToken: null,
            loading: '',
            loadings: [],
            options: {},
            filter: {
                search: '',
                sortBy: 'id',
                sortDesc: 'DESC',
            },
            onfilter: false,
            onreload: false,
            id: null,
            item: null,
            count: 0,
        }
    },
    computed: {
        count_filter: function(){
            let count = 0;
            let vue = this
            Object.entries(vue.filter).forEach((e) => {
                if(e[0] != 'sortBy' && e[0] != 'sortDesc' && e[0] != 'search' && e[0] != 'loading'){
                    if(typeof e[1] == 'object'){
                        if(e[1]){
                            if(e[1].length > 0){
                                count++
                            }
                        }
                    }else{
                        if(e[1]){
                            count++
                        }
                    }   
                }
            })
            return count;
        }
    },
    methods: {
        INIT: function () {
            let vue = this
            const source = axios.CancelToken.source()
            vue.cancelToken = source
            const { page, itemsPerPage } = vue.options
            let query = {
                page: page,
                itemsPerPage: itemsPerPage,
            }
            Object.entries(vue.filter).forEach((e) => {
                query[e[0]] = e[1]
            })
            axios({
                url: '/closing/deliver-routes',
                method: 'GET',
                params: query,
                cancelToken: source.token,
            })
                .then((resp) => {
                    vue.items = resp.data
                    vue.loading = ''
                })
                .catch((err) => {
                    if (err.code !== 'ERR_CANCELED') {
                        if (err.response.status === 402) {
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }
                        vue.loading = ''
                    }
                })
        },
        SORT: function () {
            let vue = this
            if (vue.cancelToken) {
                vue.cancelToken.cancel("Solicitud cancelada");
            }
            vue.filter.sortDesc = vue.filter.sortDesc == 'ASC' ? 'DESC' : 'ASC'
            vue.loading = 'sort'
            vue.INIT()
        },
        ONFILTER: function(){
            let vue = this
            vue.onfilter = false
            vue.onreload = false
            vue.loading = 'table'
            if (vue.cancelToken) {
                vue.cancelToken.cancel("Solicitud cancelada");
            }
            vue.INIT()
        },
        FILTER: function () {
            let vue = this
            let count = 0
            if (vue.filter.search.length > 0) {
                count++
            }
            if (count > 0) {
                vue.loading = 'filter'
                if (vue.cancelToken) {
                    vue.cancelToken.cancel("Solicitud cancelada");
                }
                vue.INIT()
            }
        },
        CLEAR: function () {
            let vue = this
            vue.loading = 'clear'
            vue.filter = {
                sortBy: 'id',
                sortDesc: 'DESC',
            }
            if (vue.cancelToken) {
                vue.cancelToken.cancel("Solicitud cancelada");
            }
            vue.INIT()
        },
        PRINT: function(print, index){
            let vue = this
            if(vue.loadings.filter(e => e == index).length == 0){
                vue.loadings.push(index)
                axios({url: '/print/deliver-route/' + print + '/closing', method: 'GET', timeout: 60000, responseType: 'blob' })
                .then((response) => {
                    vue.loadings.splice(vue.loadings.findIndex(e => e == index), 1)
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(response.data)
                    link.target = '_blank'
                    link.rel = "noopener"
                    link.click()
                })
                .catch((err) => {
                    if (err.code === 'ECONNABORTED') {
                        axios({
                            url: '/job/print/deliver-route/' + print + '/closing',
                            method: 'GET' })
                        .then((resp) => {
                            vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                            vue.loadings.splice(vue.loadings.findIndex(e => e == index), 1)
                        })
                        .catch((err) => {
                            vue.loadings.splice(vue.loadings.findIndex(e => e == index), 1)
                        })
                    } else {
                        if (err.response.status === 402) {
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }
                        vue.loadings.splice(vue.loadings.findIndex(e => e == index), 1)
                    }
                })
            }
        },
        ACTION: function(item){
            let vue = this
            vue.item = item
            vue.item.revert = true
            vue.onreload = true
        },
    },
    watch: {
        options: {
            handler() {
                if (this.cancelToken) {
                    this.cancelToken.cancel("Solicitud cancelada");
                }
                this.loading = 'table'
                this.INIT()
            },
            deep: true
        }
    }
}
</script>
